import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

// Limpar sessão inválida ao arrancar (refresh token expirado)
supabase.auth.getSession().then(({ error }) => {
  if (error && error.message.toLowerCase().includes('refresh token')) {
    supabase.auth.signOut();
  }
});

